import React from 'react';
import { UI_Modal } from "../../../../../UiComponents/index";

function AlertModal(props) {
    const {
        alertModal, setAlertModal, errorMesg
    } = props;
    const handleClose = () => setAlertModal(false)
    const closeModal = () => setAlertModal(false)


    return (
        <>
            <UI_Modal
                isOpen={alertModal}
                closeModal={() => closeModal()}
                title={"Formats not supported"}
            >
                <div className="flex px-2 py-2  m-3 sccess_text items-start text-white">
                    <div className="sccess_text">
                        <h1>{'Supported formats .jpeg .png .jpg'}</h1>
                    </div>
                </div>

                <div className="flex btn_container">
                    <button className="submit_btn_ui"
                        onClick={() => handleClose()}

                    >Close</button>
                </div>
            </UI_Modal>
        </>
    )
}

export default AlertModal